import { render, staticRenderFns } from "./IP_DocAssessmentPrintable.vue?vue&type=template&id=377afd4c&scoped=true&"
import script from "./IP_DocAssessmentPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_DocAssessmentPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_DocAssessmentPrintable.vue?vue&type=style&index=0&id=377afd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377afd4c",
  null
  
)

export default component.exports